import { useMutation } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

export interface ResolveMappingVariables {
  merchantSku: string;
  sinoSku: string;
}

/**
 * Map a merchant SKU to a Sino SKU (resolves an ingest-stage hold cause).
 * PUT /v1/sku-mappings/{merchant_sku}
 * On error throws — caller chains retry-ingest on success.
 * 422 skumap_unknown_sino → caller surfaces inline row error.
 */
export function useResolveMapping() {
  return useMutation({
    meta: { silentError: true },
    mutationFn: async ({ merchantSku, sinoSku }: ResolveMappingVariables) => {
      const { data, error } = await apiClient.PUT("/v1/sku-mappings/{merchant_sku}", {
        params: { path: { merchant_sku: merchantSku } },
        body: { sino_sku: sinoSku },
      });
      if (error) throw error;
      return data;
    },
  });
}
